const MODULE_NAMES = {
  CPL2: "Proptimo Core",
  CPL3: "Proptimo",
};

export { MODULE_NAMES };
